import React from 'react';

export const Knowledge = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_181_52398"
      className="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="21"
    >
      <rect x="0.852051" y="0.849487" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_181_52398)">
      <path
        d="M16.5604 19.162C16.4493 19.162 16.3451 19.1448 16.2479 19.1103C16.1507 19.0753 16.0604 19.0161 15.977 18.9328L11.5604 14.5161V13.6828L13.6645 11.5786H14.4979L18.9145 15.9953C18.9979 16.0786 19.057 16.1689 19.092 16.2661C19.1265 16.3634 19.1437 16.4675 19.1437 16.5786C19.1437 16.6898 19.1265 16.7939 19.092 16.8911C19.057 16.9884 18.9979 17.0786 18.9145 17.162L17.1437 18.9328C17.0604 19.0161 16.9701 19.0753 16.8729 19.1103C16.7757 19.1448 16.6715 19.162 16.5604 19.162ZM16.5604 17.1828L17.1645 16.5786L13.6229 13.037L13.0187 13.6411L16.5604 17.1828ZM5.12287 19.1828C5.01176 19.1828 4.90426 19.162 4.80037 19.1203C4.69593 19.0786 4.60204 19.0161 4.51871 18.9328L2.76871 17.1828C2.68537 17.0995 2.62287 17.0056 2.58121 16.9011C2.53954 16.7973 2.51871 16.6898 2.51871 16.5786C2.51871 16.4675 2.53954 16.3634 2.58121 16.2661C2.62287 16.1689 2.68537 16.0786 2.76871 15.9953L7.18537 11.5786H8.95621L9.66454 10.8703L6.22704 7.43282H5.03954L2.51871 4.91198L4.87287 2.55782L7.39371 5.07865V6.26615L10.8312 9.70365L13.2479 7.28698L12.352 6.39115L13.5187 5.22448H11.1645L10.5812 4.64115L13.5395 1.68282L14.1229 2.26615V4.62032L15.2895 3.45365L18.2479 6.41198C18.4979 6.64809 18.682 6.91893 18.8004 7.22448C18.9182 7.53004 18.977 7.84254 18.977 8.16198C18.977 8.48143 18.9182 8.79393 18.8004 9.09948C18.682 9.40504 18.4979 9.68282 18.2479 9.93281L16.477 8.16198L15.3104 9.32865L14.4354 8.45365L10.1229 12.7661V14.5161L5.70621 18.9328C5.62287 19.0161 5.5326 19.0786 5.43537 19.1203C5.33815 19.162 5.23398 19.1828 5.12287 19.1828ZM5.12287 17.1828L8.66454 13.6411L8.06037 13.037L4.51871 16.5786L5.12287 17.1828Z"
        fill="#7D7A9A"
      />
    </g>
  </svg>
);
